import { IRootState } from '../../../store'
import { IVentilatorOptionsState } from '../store/options.types'

export const getVentilatorOptionsSelector = (state: IRootState): IVentilatorOptionsState =>
  state.options.ventilatorOptions
